export enum Service {
  EMS = 'ems',
  HTTP = 'http',
  NMOS = 'nmos',
  PREVIEW = 'preview',
  SNMP = 'snmp',
  SSH = 'ssh',
  TELNET = 'telnet',
}
